var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighContrastSaturation = function SvgHighContrastSaturation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc300",
    d: "M12 1.125v21.75A10.873 10.873 0 0 0 19.69 4.31 10.87 10.87 0 0 0 12 1.125",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#ffcb21",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.125v21.75M12 22.875c6.006 0 10.875-4.869 10.875-10.875S18.006 1.125 12 1.125 1.125 5.994 1.125 12 5.994 22.875 12 22.875z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcb21",
    d: "M11.625 22.5v-21c-2.685 0-5.261 1.106-7.159 3.075S1.5 9.215 1.5 12s1.067 5.456 2.966 7.425S8.94 22.5 11.625 22.5",
    opacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgHighContrastSaturation;